import { SubscriptionRecord } from "./stuffAdapters";

export const subscriptionsData: SubscriptionRecord[] = [
  {
    id: "subscription-001",
    serialNo: 1,
    date: "2025-10-09",
    orderNo: "SKN-123456HNGBMN",
    status: "Active",
    productName:
      "GRECILOOKS Women's Tops – Crop Top, Loose Fit Oversized Shirts & Stylish Korean Tank Tops for Summer Wear",
    description:
      "Premium fashion subscription benefit with a one-year validity period and selected Salar purchase privileges.",
    productImage:
      "https://images.unsplash.com/photo-1525507119028-ed4c629a60a3?auto=format&fit=crop&w=520&q=80",
    price: 10000,
    quantity: 1,
    validity: "1 Year",
    startDate: "2025-10-10",
    endDate: "2026-10-10",
  },
  {
    id: "subscription-002",
    serialNo: 2,
    date: "2025-08-01",
    orderNo: "SKN-123456HNGBMN",
    status: "Active",
    productName:
      "Apple AirPods (3rd generation) with Lightning Charging Case",
    description:
      "Eligible subscription purchase with extended access to Salar member benefits for the validity period.",
    productImage:
      "https://images.unsplash.com/photo-1600294037681-c80b4cb5b434?auto=format&fit=crop&w=520&q=80",
    price: 22000,
    quantity: 1,
    validity: "1 Year",
    startDate: "2025-10-10",
    endDate: "2026-10-10",
  },
  {
    id: "subscription-003",
    serialNo: 3,
    date: "2025-06-18",
    orderNo: "SKN-682941ABCDXY",
    status: "Expired",
    productName: "Salar Shopping Voucher 1000",
    description:
      "A completed subscription benefit retained in your account for purchase history and records.",
    productImage:
      "https://images.unsplash.com/photo-1549465220-1a8b9238cd48?auto=format&fit=crop&w=520&q=80",
    price: 1000,
    quantity: 1,
    validity: "6 Months",
    startDate: "2025-01-10",
    endDate: "2025-07-10",
  },
  {
    id: "subscription-004",
    serialNo: 4,
    date: "2025-05-02",
    orderNo: "SKN-478120PQRSTU",
    status: "Active",
    productName: "Premium Lifestyle Membership",
    description:
      "Active Salar lifestyle membership with selected shopping privileges and promotional access.",
    productImage:
      "https://images.unsplash.com/photo-1523779917675-b6ed3a42a561?auto=format&fit=crop&w=520&q=80",
    price: 4999,
    quantity: 1,
    validity: "1 Year",
    startDate: "2025-05-03",
    endDate: "2026-05-03",
  },
];
